<template>
  <div>
    <div class="cms">
      <div class="cms-header">
        <h1>{{ cmsInfo.cmsTitile }}</h1>
        <div class="cms-info">
          <span class="gap">本文发布于：{{ cmsInfo.createTime }}</span>
          <!-- <a-divider type="vertical"></a-divider>
        <a-icon type="user" />
        <span class="gap">发布人：{{ cmsInfo.createBy }}</span>
        <a-divider type="vertical"></a-divider>
        <a-icon type="eye" />
        <span class="gap">浏览数：{{ cmsInfo.viewNum }}</span> -->
        </div>
      </div>

      <a-divider></a-divider>

      <div class="article-content" v-html="cmsInfo.cmsContent"></div>
      <div class="extra-file" v-if="cmsInfo.extraFile">
        <p>附件：</p>
        <p v-for="(v, k, i) in extraFilename" :key="i">
          <span>{{ i + 1 }}. </span>
          <a
            :href="$store.getters.tenantInfo.qiniuDomain + '/' + k"
            target="_blank"
            >{{ v }}</a
          >
        </p>
      </div>
    </div>
    <a-divider></a-divider>
    <a-card :bordered="false" v-if="cmsInfo.canReply == 1">
      <!-- 评论区 -->
      <div class="project-comment">
        <div class="publish">
          <a-row type="flex" justify="space-between">
            <a-col span="3" class="comment-user">
              <a-avatar
                shape="square"
                :size="60"
                icon="user"
                :src="avatarUrl"
              />
              <p>
                {{
                  $store.state.user.info && $store.state.user.info.realname
                    ? $store.state.user.info.realname
                    : "未登录"
                }}
              </p>
            </a-col>
            <a-col :span="16">
              <a-textarea
                v-model="commentContent"
                :rows="5"
                :maxLength="500"
                placeholder="说说这个作品怎么样吧"
              ></a-textarea>
            </a-col>
            <a-col :span="4">
              <div class="comment-btn">
                <a-button :disabled="!token" type="dashed" @click="comment"
                  >发表评论</a-button
                >
              </div>
            </a-col>
          </a-row>
        </div>
        <a-divider />
        <a-list
          class="comment-list"
          item-layout="horizontal"
          :locale="{ emptyText: '暂无评论' }"
          :data-source="comments"
        >
          <a-list-item slot="renderItem" slot-scope="item">
            <a-comment
              :author="item.nickname || item.realname || item.username"
            >
              <a-avatar
                shape="square"
                :size="40"
                slot="avatar"
                icon="user"
                :src="item.avatar"
              />
              <p class="comment-content" slot="content">
                {{ item.comment }}
              </p>
              <a-tooltip
                slot="datetime"
                :title="moment(item.createTime).format('YYYY-MM-DD HH:mm:ss')"
              >
                <span>{{ moment(item.createTime).fromNow() }}</span>
              </a-tooltip>
            </a-comment>
          </a-list-item>
          <div
            v-if="showLoadingMore"
            slot="loadMore"
            :style="{
              textAlign: 'center',
              marginTop: '12px',
              height: '32px',
              lineHeight: '32px',
            }"
          >
            <a-spin v-if="loadingMore" />
            <a-button type="link" v-else @click="workComments">
              加载更多
            </a-button>
          </div>
        </a-list>
      </div>
    </a-card>
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import { ACCESS_TOKEN } from "@/store/mutation-types";
import { getAction, postAction } from "@/api/manage";
import moment from "moment";
export default {
  data() {
    return {
      cmsInfo: {},
      extraFilename: {},
      commentContent: "",
      showLoadingMore: true,
      loadingMore: false,
      commentsPage: 0,
      comments: [],
      token: "",
    };
  },
  computed: {
    avatarUrl() {
      if (this.$store.state.user.info && this.$store.state.user.info.avatar) {
        return this.$store.state.user.info.avatar;
      } else {
        return "/img/avatar.png";
      }
    },
  },
  watch: {
    $route(to, from) {
      this.getCmsDetail();
    },
  },
  created() {
    this.token = Vue.ls.get(ACCESS_TOKEN);
    this.getCmsDetail();
  },
  methods: {
    ...mapGetters(["nickname", "avatar", "userInfo"]),
    moment,
    getCmsDetail() {
      getAction(
        "/teaching/teachingCms/getCmsDetail?id=" + this.$route.query.id
      ).then((res) => {
        if (res.success) {
          this.cmsInfo = res.result;
          this.extraFilename = JSON.parse(this.cmsInfo.extraFilename);
          this.workComments();
        }
      });
    },
    workComments() {
      this.commentsPage += 1;
      this.loadingMore = true;
      getAction("/teaching/comment/queryCommentBySourceId", {
        id: this.cmsInfo.id,
        page: this.commentsPage,
      }).then((res) => {
        this.loadingMore = false;
        if (res.result.length == 0 && this.commentsPage > 1) {
          this.$message.info("已加载完啦！");
        } else {
          this.comments = this.comments.concat(res.result);
        }
      });
    },
    comment() {
      if (this.commentContent != "") {
        postAction("/teaching/comment/saveComment", {
          sourceType: '2',
          sourceId: this.cmsInfo.id,
          comment: this.commentContent,
        }).then((res) => {
          if (res.success) {
            this.comments.unshift({
              comment: this.commentContent,
              realname: this.$store.state.user.info.realname,
              avatar: this.avatarUrl,
              createTime: new Date(),
            });
            this.commentContent = "";
            this.$message.success(res.message);
          }
        });
      }
    },
  },
};
</script>

<style scoped lang="less">
.cms {
  border-radius: 10px;
  background: white;
  padding: 20px 0;
  margin: 20px 0;
  box-shadow: #c5c0c0 0px 0px 10px;
  min-height: 80vh;
}
.cms-header {
  margin-top: 20px;
  text-align: center;
  h1 {
    margin: 0 50px;
  }
  .cms-info {
    color: gray;
  }
}

.gap {
  margin-left: 5px;
  margin-right: 20px;
  font-size: 14px;
}
.article-content {
  overflow: auto;
  padding: 20px 100px;
  /deep/img {
    max-width: 100%;
    height: auto;
  }
}
.extra-file {
  padding: 20px 100px;
}
.project-comment {
  padding: 10px;
  .publish {
    .comment-user {
      text-align: center;
      padding-top: 20px;
    }
    .comment-btn {
      padding-top: 10px;
      button {
        height: 80px;
      }
    }
  }
  .comment-list {
    color: #999;
    border: 1px solid #e9e9e9;
    border-top: none;
    padding: 0 20px;
    .comment-content {
      width: 600px;
    }
    .item {
      padding: 20px;
      font-size: 13px;
      border-bottom: 1px solid #e9e9e9;

      .people {
        font-size: 30px;
      }
      .user {
        color: #666;
        font-size: 14px;
        margin-right: 5px;
      }
      .time {
        font-size: 12px;
      }
      span {
        margin-right: 30px;
      }
      p {
        margin: 10px 0;
      }
    }
    .more {
      font-size: 13px;
      text-align: center;
      padding-top: 40px;
      padding-bottom: 20px;
      > span {
        border: 1px solid #e9e9e9;
        line-height: 47px;
        width: 140px;
        height: 47px;
        display: inline-block;
        color: #999;
      }
    }
  }
}
</style>